import { MaterialesService } from "../services/materiales.service";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromActions from '../actions';
import { exhaustMap, map, switchMap } from "rxjs/operators";
import { from } from "rxjs";
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTER_PATH } from '../app-routing.module';
import { getLanguageFromUrl } from '../language';

@Injectable()
export class MaterialesEffects {
  constructor(
    private materialesService: MaterialesService,
    private router: Router,
    private actions$: Actions
  ) { }

  loadMaestros = createEffect(() => this.actions$.pipe(
    ofType(fromActions.loadMaestrosMaterialRequest),
    exhaustMap(() => from(this.materialesService.getMaestros()).pipe(
      map(maestros => fromActions.loadMaestrosMaterial(maestros))
    ))
  ))

  selectStockItem = createEffect(() => this.actions$.pipe(
    ofType(fromActions.selectStockItem),
    map(({ item }) => this.materialesService.serializeDetailsParams(item)),
    map(queryParams => this.router.navigate([getLanguageFromUrl(), ROUTER_PATH.DETAIL], { queryParams }))
  ), {dispatch: false})

  deserializeDetailsParams = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deserializeDetailsParams),
    map(({ query }) => this.materialesService.deserializeDetailsParams(query)),
    map(params => fromActions.loadDetailsRequest({ params }))
  ))

  loadDetailsRequest = createEffect(() => this.actions$.pipe(
    ofType(fromActions.loadDetailsRequest),
    switchMap(({ params }) => this.materialesService.getDetalles(params).pipe(
      map(detalles => fromActions.loadDetails({ detalles }))
    ))
  ))

  loadMaterialesSimilaresRequest = createEffect(() => this.actions$.pipe(
    ofType(fromActions.loadMaterialesSimilaresRequest),
    switchMap(({param}) => this.materialesService.getMaterialesSimilares(`similares=${param}`).pipe(
      map(materiales => fromActions.loadMaterialesSimilares({ materiales }))
    ))
  ))


}
